<div #leftSidePanelHeader id="left-side-pnel-header" class="flex-1">
	<ul ngbNav #nav="ngbNav" [(activeId)]="activeTab" class="nav nav-tabs" justified="true" [destroyOnHide]="false">
	  <li class="nav-item" *ngFor="let tab of tabs; let i = index" [ngbNavItem]="i" [hidden]="tab.hide">
	    <a class="nav-link" ngbNavLink (click)="activeTab = tab.id; toggleTab();">
	      {{ tab.title }}
	    </a>
	  </li>
	  
	  <!-- 'More' dropdown tab -->
	  <li class="nav-item dropdown" ngbDropdown>
	    <a class="nav-link dropdown-toggle" id="dropdownTab" data-bs-toggle="dropdown" role="button" aria-expanded="false" aria-haspopup="true" ngbDropdownToggle>
	      {{LOCALIZATION.morePanel}}<span class="caret"></span>
	    </a>
	    <ul class="dropdown-menu" aria-labelledby="dropdownTab" ngbDropdownMenu role="menu">
	      <li *ngFor="let option of dropdownOptions; let i = index" [ngbNavItem]="i" [hidden]="option.hide">
	        <a class="dropdown-item" ngbNavLink (click)="activeTab = option.id; toggleTab();">
	          {{ option.title }}
	        </a>
	      </li>
	    </ul>
	  </li>	  
	  
	</ul>
	<div [ngbNavOutlet]="nav"></div>
</div>
<div id="kv_advanced_panel" class="panel-body flex-19" [ngStyle]="panelStyling">
  <ng-container>
        <div [hidden]="activeTab !== 'c'" class="tab-pane">
            <div class="flex-19;">
				<collection [fields]="searchInputs" (triggerUpdateSearch)="onUpdateSearch()"></collection>
            </div>
            <div style='flex:1;width:100%;text-align:center;'>
                <button (click)='onUpdateSearch()' class='btn btn-md btn-primary'>{{LOCALIZATION.updateSearchCriteria}}</button>
            </div>
        </div>
        
        <div [hidden]="activeTab !== 'f'" class="tab-pane">
			<facets></facets>
        </div>
        
        <div [hidden]="activeTab !== 'b'" class="tab-pane">
            <div id="browsecontent" class='browse-content' style="height:100%">
                <browse-view></browse-view>
            </div>
        </div>
        
        <div [hidden]="activeTab !== 's'" class="tab-pane">
               <h5 class="panel-heading">{{LOCALIZATION.searchHistory}}</h5>
               <search-history></search-history>
               
               <div *ngIf="loggedIn && userPermissions['ROLE_NOTIFICATION_CREATE']">
                   <h5 class="panel-heading">{{LOCALIZATION.savedSearches}}</h5>
                   <my-searches></my-searches>
               </div>
        </div>
        
        <div [hidden]="activeTab !== 'a'" class="tab-pane">
               <div id="geo-locate-content" class='geo-locate-content'>
                   <div style="height:100%">
                       <h5 class="panel-heading">{{LOCALIZATION.savedLocationsSearch}}</h5>
                       <geo-locate></geo-locate>
                   
                       <div *ngIf="advancedConfig.savedLocations.enabled && loggedIn" style="padding-top: 24px;">
                           <h5 class="panel-heading">{{LOCALIZATION.savedLocations}}</h5>
                           <saved-locations></saved-locations>
                       </div>
                   </div>
               </div>        
        </div>
        
        <div [hidden]="activeTab !== 'm'" class="tab-pane">
			<map-results-view></map-results-view>
        </div>        
        
        <div [hidden]="activeTab" class="tab-pane">
            <div class="flex-19;">
				<collection [fields]="searchInputs" (triggerUpdateSearch)="onUpdateSearch()"></collection>
            </div>
            <div style='flex:1;width:100%;text-align:center;'>
                <button (click)='onUpdateSearch()' class='btn btn-md btn-primary'>{{LOCALIZATION.updateSearchCriteria}}</button>
            </div>
        </div>	        	  
  </ng-container>
</div>
